import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Size, SetStyles, Rect } from "../.././MyHelpers";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { PickBonus2, PickBonus2Params, PickBonusFactory2 } from "./PickBonus2";
import { PickBonusCashReward, PickBonusJackpotReward } from "./PickBonusParams";
import { PickJackpot } from "./PickJackpot";
import { PickBonusMessages } from "./PickMessage";
import { ZIndex } from "../../ZIndex";

export class PickBonus2_2Screen extends PickBonus2
{
	protected override fontHeight:number=100;

	
	public constructor(gameResid: ResourceIdentifier, params: PickBonus2Params) 
	{
	super(gameResid,params);


	}
	//CHANGE POSION JP1=JP2 and JP2=JP1
	public override BaseLoaded(resourceManager:ResourceManager):void
	{
		
		this.jp1Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp1", "image"]));
		this.jp2Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp2", "image"]));
		this.jp3Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp3", "image"]));
		this.jp4Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp4", "image"]));
	}

	protected override BasePrepare(resourceManager:ResourceManager):void
    {
		super.BasePrepare(resourceManager);
        resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/SAPPHIRE.png", this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/EMMERALD.png", this.resid.ScopedResourceName(["jp1", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/RUBY.png", this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/GOLD.png", this.resid.ScopedResourceName(["jp4", "image"])));
	}



	//CHANGE POSION JP1=JP2 and JP2=JP1
	public override SpriteWinFrameLoaded(resourceManager: IReadOnlyResourceManager)
	{
		
		//CHANGE TO SPRITE 
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
		this.FrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(700,400)});
		//this.FrameSprite.View().style.zIndex="4";
		this.FrameSprite.View().style.position="absolute";
		this.FrameSprite.View().style.top= "-28px";
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		
	
			//ADD NEW FRAME SPRITE IN CONTAINER
			this.winContainer.appendChild(this.FrameSprite.View());
	}

	protected override CanvaswinCount()
	{
		this.winCountcanvas=document.createElement("canvas");
		this.winCountcanvas.width = 700;
		this.winCountcanvas.height = 142;
		this.winCountcanvas.style.left = 71+ "px";
		this.winCountcanvas.style.top = 105 + "px";
		this.winCountcanvas.style.position = "absolute";
		this.winCountcanvas.style.display = "flex";
		this.winCountcanvas.style.alignItems = "center";
		this.winCountcanvas.style.justifyContent = "center";
		//this.winCountcanvas.style.zIndex="3";
		this.winCountcanvas.style.zIndex = ""+ ZIndex.BonusWin;

		//add gradient
		this.ctx = this.winCountcanvas.getContext("2d");
		
       // this.ctx.font = "120px Verdana" /*+ this.font*/;
		this.ctx.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("BonusWinFont");

		let color:string="orangered";
		let color2:string="yellow";

		let gradient = this.ctx.createLinearGradient( this.winCountcanvas.width /2, 
			this.winCountcanvas.height /2 - this.fontHeight/2, 
			this.winCountcanvas.width /2, 
			this.winCountcanvas.height /2 + this.fontHeight/2
		);
		
		gradient.addColorStop(0,color);
			
		gradient.addColorStop(0.10,color);
		
		
		gradient.addColorStop(0.70,color2);
		
		gradient.addColorStop(1,color2);
		
		this.ctx.fillStyle = gradient;
		this.ctx.shadowColor="black";
		this.ctx.shadowOffsetX = 1;
		this.ctx.shadowOffsetY = 1;
		this.ctx.shadowBlur = 2;
		
		
		//this.ctx.textBaseline = "hanging";
		this.ctx.textBaseline = "top";
		this.ctx.textAlign="center";

		
			

	}

	protected override WinContainerLoaded(resourceManager:ResourceManager):void
	{
		super.WinContainerLoaded(resourceManager);

		SetStyles(this.winContainer,
			{
				position : "absolute",
				top: "407px",
				left: "0px",
				width: "44%",
				height: "350px",
				display:"flex",
				flexDirection:"column",
				justifyContent:"center",
				alignItems:"center",
				zIndex:"3",
			});

			SetStyles(this.winBackDark,
				{
					height:"144px",
					width:"647px",
					background:"RGBA(0,0,0,1)",
					zIndex:"0",
					top:"98px",
					position:"absolute",
					left:"102px"
				});
				SetStyles(this.totalWinText,
					{
						height: "38%",
						width: "53%",
						fontSize: "80px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
			
						backgroundImage:resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bonusWin", "image"])).CssBackground(),
						backgroundRepeat: "no-repeat",
						backgroundSize: "contain",
						backgroundPosition:"center",
						zIndex:"3",
						position:"absolute",
						top:"-20px",
					});
	}

	protected override PrepareinfoContainer(resourceManager:ResourceManager)
	{
		super.PrepareinfoContainer(resourceManager);

		SetStyles(this.infoContainer,
			{
				
				top:"719px",
				width:"54%",
			});


			SetStyles(this.pickLeft,
				{
					height:"100%",
					width:"50%",
					fontSize: "45px",
					fontFamily: "NotoSansDisplay-BoldItalic",
					color: "white",
					display:"flex",
					justifyContent:"center",
					alignItems:"center",
					zIndex:"2",
					textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
					position:"relative",
					left:"-81px",
		
				});
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager:ResourceManager): Promise<void>
	{
		await super.ResourcesLoaded(loadingStage, resourceManager);
		SetStyles(this.jackpotContainer, 
			{
				bottom: "10px",
				width : "54%",
				height : "21%"
			});
	}
	//COPY ALL BECAUSE ITS PRIVATE WE NEED ANOTHER POSITION IN AWARDRECT
	protected override Win(message:PickBonusMessages.AwardMessage):void
	{
		this.award = message.award;
		let pickRect: Rect = message.pick;
		let awardRect: Rect = null;

		if(this.award.PickType == 1)
		{
			let money:number = (this.award as PickBonusCashReward).Reward.InCents;
			this.session.totalWin += money;
			//this.winContainer.innerHTML = ""+this.session.totalWin;

			//CHANGE POSTION IT MOVE BONUS WIN
			awardRect = new Rect(0,450,850,200);

			//this.NextPick();
		}
		else if (this.award.PickType == 2)
		{
			let currentJackpot:PickJackpot = this.pickJackpots.get((this.award as PickBonusJackpotReward).JackpotName);
			//let freeSpotForJackpot:number = award.JackpotCount-1;
			this.session.totalWin += (this.award as PickBonusJackpotReward).WinAmount.InCents;

			awardRect = currentJackpot.CenterOfFreeSpaceForDiamond(this.award);
		}

		this.screenProtocol.Send(new PickBonusMessages.CommetDestination(awardRect),this.screenProtocolScope);
	}

	protected override OnCometePickComplete(message:PickBonusMessages.CommetPickComplete):void
	{
		if(this.award.PickType ==1)
		{
			//this.winCount.innerHTML = this.moneyFormatter.FormatCurrency(this.session.totalWin);
			//CHANGE SIMPLE TEXT TO CANVAS 
			this.fillTextCanvas(this.moneyFormatter.FormatCurrency(this.session.totalWin));
			//PLAY SPRITE ONLY ONE TIME
			this.FrameSprite.Start(false);
			
		}

		else if(this.award.PickType ==2)
		{
			let jackpotReward = (this.award as PickBonusJackpotReward)
			let currentJackpot:PickJackpot = this.pickJackpots.get(jackpotReward.JackpotName);
			//let destRect = currentJackpot.CenterOfFreeSpaceForDiamond(this.award);
			let freeSpotForJackpot = currentJackpot.JpFreeSpot(jackpotReward.JackpotCount);
		
			this.AddJp(jackpotReward.JackpotName, jackpotReward.JackpotCount);
			if(freeSpotForJackpot < currentJackpot.WinContainer().length)
			{
				
				if(jackpotReward.JackpotName == "jp1")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp1Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(1100,849,601,114),new Rect(0,450,850,200)),this.screenProtocolScope);
					
					
					}
				}
				else if(jackpotReward.JackpotName == "jp2")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp2Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(1100,610,601,114),new Rect(0,450,850,200)),this.screenProtocolScope);
					}

				}
				else if(jackpotReward.JackpotName == "jp3")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp3Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(599,352,1270,181),new Rect(0,450,850,200)),this.screenProtocolScope);
					}
				}
				else if(jackpotReward.JackpotName == "jp4")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp4Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(599,100,1326,197),new Rect(0,450,850,200)),this.screenProtocolScope);
					}
				}
				else
				{
					throw new Error("Unknown jackpot "+ jackpotReward.JackpotName);
				}	
			} 
		}

		//this.titleSprite.Start(false);
		
	}

	

}

export class PickBonusFactory2_2Screen extends PickBonusFactory2
{
	
	public override CreatePickBonus2(gameName: ResourceIdentifier, params: PickBonus2Params): PickBonus2
	{
		
		return new PickBonus2_2Screen(gameName, params);
	}
}